import React from 'react';
import { Box, Typography, alpha } from '@mui/material';
import PropTypes from 'prop-types';

const DashboardContainer = ({ title, children, action, sx = {} }) => {
    return (
        <Box
            sx={{
                backgroundColor: (theme) => theme.palette.background.paper,
                borderRadius: 3,
                border: (theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
                boxShadow: '0 1px 6px rgba(0, 0, 0, 0.2)',
                overflow: 'hidden',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                ...sx,
            }}
        >
            <Box
                sx={{
                    px: { xs: 2, md: 3 },
                    py: 2,
                    borderBottom: (theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                }}
            >
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 700,
                        fontSize: { xs: '0.9rem', md: '1.125rem' },
                        color: (theme) => theme.palette.text.primary,
                    }}
                >
                    {title}
                </Typography>
                {action && action}
            </Box>

            <Box sx={{ px: { xs: 2, md: 3 }, py: 0.5, flex: 1, display: 'flex', flexDirection: 'column' }}>{children}</Box>
        </Box>
    );
};

DashboardContainer.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    action: PropTypes.node,
    sx: PropTypes.object,
};

export default DashboardContainer;